import axios from "axios";
import {getPharmacyId} from "../../helpers/Utils";
import * as URL from "../../helpers/Constants";


export default class PMSDuePaymentServices {

    static getDuePayments(params) {
        return axios.get(`${URL.PMS_GET_DUE_PAYMENTS_BY_PHARMACY_ID}/${getPharmacyId()}`, {
            ...PMSDuePaymentServices.getAuthHeader(), params,
        });
    }

    static getPaidPayments(params) {
        return axios.get(`${URL.PMS_GET_PAID_PAYMENTS_BY_PHARMACY_ID}/${getPharmacyId()}`,
            {...PMSDuePaymentServices.getAuthHeader(), params}
        )
    }

    static confirmDuePayment(id) {
        return axios.put(``, null, PMSDuePaymentServices.getAuthHeader());
    }

    static confirmDuePaymentWithDetails(id, data) {
        return axios.put(`${URL.PMS_CONFIRM_DUE_PAYMENT_BY_ID}/${id}/${getPharmacyId()}`, data,
            PMSDuePaymentServices.getAuthHeader()
        );
    }

    static cancelDuePayment(id) {
        return axios.delete(`${URL.PMS_CANCEL_DUE_PAYMENT_BY_ID}/${id}/${getPharmacyId()}`, PMSDuePaymentServices.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        };
    }
}
